module.exports = __webpack_public_path__ + "static/logo-girl-e9fbb4365ab34ca34cbc6d365614e7f7.png";